import styled from 'styled-components';

import {colors} from '@app/styles/theme';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    background: ${colors.background};
`;

export const HeaderCard = styled.div`
    padding: 20px;
    background: ${colors.white};
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.15);
`;

export const BackButton = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 10px;
    border: 0;
    background: transparent;
    padding: 0;
    color: ${colors.brandPrimary};
    cursor: pointer;
    font: inherit;
    margin-bottom: 12px;

    &:hover {
        color: ${colors.brandDark};
    }
`;

export const SectionCard = styled.div`
    padding: 20px;
    background: ${colors.white};
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.15);
`;

export const MessagesHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 16px;
    margin-bottom: 12px;
`;

export const Actions = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-left: auto;
`;

export const Form = styled.form`
    display: contents;
`;

export const Field = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

export const CheckboxRow = styled.label`
    display: flex;
    align-items: center;
    gap: 10px;
    color: ${colors.textPrimary};
    font-size: 14px;
    cursor: pointer;
`;

export const FieldError = styled.div`
    color: ${colors.danger};
    font-size: 12px;
    line-height: 16px;
`;

export const InfoGrid = styled.div`
    display: grid;
    gap: 16px;
`;

export const InfoItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

export const InfoLabel = styled.div`
    color: ${colors.textSecondary};
    font-size: 13px;
`;

export const InfoValue = styled.div`
    color: ${colors.textPrimary};
    font-size: 14px;
    font-weight: 500;
`;

export const BodyPreview = styled.code`
    display: block;
    max-height: 320px;
    overflow: auto;
    white-space: pre-wrap;
    word-break: break-word;
    color: ${colors.textPrimary};
    font-size: 13px;
    line-height: 20px;
`;

export const ModalFrame = styled.iframe`
    width: 100%;
    height: 500px;
    border: 0;
`;
